import { useState } from "react";
import type { BookingLesson } from "../api.js";
import { useOptionalAuth } from "../auth.js";
import { SelectedLessonActions } from "../booking/SelectedLessonActions.js";
import { lessonSelectionAccess, type SelectedLesson } from "../booking/selectedLessons.js";
import "./studentLessonManager.css";

export function LessonCreditAction({ booking, disabled, onChanged }: { booking: BookingLesson["booking"]; disabled: boolean; onChanged: () => void }) {
  const auth = useOptionalAuth();
  const [selection, setSelection] = useState<SelectedLesson[] | null>(null);
  if (!lessonSelectionAccess(auth?.me).credit || !booking.studentId || !booking.ameliaAppointmentId || !booking.ameliaBookingId) return null;
  return <div className="lesson-note-credit-action">
    <button type="button" className="quiet" disabled={disabled} onClick={() => setSelection([{ bookingId: booking.bookingId, appointmentId: booking.ameliaAppointmentId!, startsAt: booking.startsAt, endsAt: booking.endsAt, serviceName: booking.serviceName }])}>Apply block credit</button>
    <span className="small muted">Use an available credit for this lesson.</span>
    {selection && <SelectedLessonActions studentId={booking.studentId} studentName={booking.studentName ?? "Student"} lessons={selection} action="credit" onClose={() => setSelection(null)} onChanged={onChanged} />}
  </div>;
}
